import React, { useEffect, useState } from "react";
import vinylSVG from "../../assets/images/vinylSVG.svg";

const VinylSVG = ({ loadingPercent }) => {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    // Ogni volta che cambia la percentuale di caricamento, aumenta la rotazione
    setRotation(loadingPercent * 3.6); // 360° = 100%, quindi 100 * 3.6 = 360°
  }, [loadingPercent]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 20,
      }}
    >
      <div
        style={{
          transform: `rotate(${rotation}deg)`,
          transition: "transform 0.1s linear",
        }}
      >
        <img
          src={vinylSVG}
          alt="Vinyl"
          style={{ width: "100%", height: "100%" }}
        />
      </div>
      <div style={{ fontSize: "24px", fontWeight: "bold" }}>
        {loadingPercent}%
      </div>
    </div>
  );
};

export default VinylSVG;
